var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip, ClickAwayListener, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Switch, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Blockchain02Icon, BubbleChatIcon, Edit02Icon, Link05Icon, MessageQuestionIcon, MoreVerticalCircle01Icon, UserGroupIcon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ProtectedElement from '../../../components/ProtectedElement';
import AiUserIcon from '../../../icons/components/ai-user';
import AssetFolderIcon from '../../../icons/components/asset-folder-icon';
import { Permissions } from '../../../permissions';
var MachineFolderCard = function (_a) {
    var id = _a.id, title = _a.title, machine = _a.machine, switchChecked = _a.switchChecked, onSwitchToggle = _a.onSwitchToggle, onClick = _a.onClick, onStartChat = _a.onStartChat, onViewTechnicians = _a.onViewTechnicians, onViewClients = _a.onViewClients, onViewFAQs = _a.onViewFAQs, onManageSerialNumbers = _a.onManageSerialNumbers, onEditMachine = _a.onEditMachine;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(min-width: 1024px) and (max-width: 1024px) and (orientation: landscape)');
    var _b = __read(useState(null), 2), openTooltipDocuments = _b[0], setOpenTooltipDocuments = _b[1];
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleClickAway = function () {
        if (openTooltipDocuments !== null) {
            setOpenTooltipDocuments(null);
        }
    };
    useEffect(function () {
        var handleScroll = function (e) {
            var _a, _b;
            var t = e.target;
            if (((_a = t === null || t === void 0 ? void 0 : t.closest) === null || _a === void 0 ? void 0 : _a.call(t, '.MuiTooltip-popper')) || ((_b = t === null || t === void 0 ? void 0 : t.closest) === null || _b === void 0 ? void 0 : _b.call(t, '[data-tooltip-scrollable]'))) {
                return;
            }
            if (openTooltipDocuments !== null)
                setOpenTooltipDocuments(null);
        };
        window.addEventListener('scroll', handleScroll, true);
        return function () {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openTooltipDocuments]);
    var menuItems = [
        {
            text: translate('assets.startChat'),
            icon: BubbleChatIcon,
            onClick: function () { return onStartChat(id); },
            color: undefined,
            permission: undefined,
            divider: true,
            disabled: machine.totalDocumentCount <= 0 || machine.isActive === false
        },
        {
            text: translate('assets.viewTechnicians'),
            icon: AiUserIcon,
            onClick: function () { return onViewTechnicians(id); },
            color: undefined,
            permissions: [Permissions.Technicians.Read],
            divider: false
        },
        {
            text: translate('assets.viewClients'),
            icon: UserGroupIcon,
            onClick: function () { return onViewClients(id); },
            color: undefined,
            permissions: [Permissions.Clients.Read],
            divider: false
        },
        {
            text: translate('assets.viewFAQs'),
            icon: MessageQuestionIcon,
            color: undefined,
            onClick: function () {
                handleMenuClose();
                onViewFAQs(id);
            },
            divider: false,
            permissions: [Permissions.Faqs.Read]
        },
        {
            text: translate('assets.modelSerialDocs'),
            icon: Blockchain02Icon,
            onClick: function () { return onManageSerialNumbers(id); },
            color: undefined,
            permissions: [Permissions.Machines.Read],
            divider: false
        },
        {
            text: translate('actions.edit'),
            icon: Edit02Icon,
            onClick: function () { return onEditMachine(id); },
            color: undefined,
            permissions: [Permissions.Machines.Update],
            divider: false
        },
        {
            text: switchChecked ? translate('common.deactivate') : translate('common.activate'),
            icon: Switch,
            onClick: function () { return onSwitchToggle(); },
            permissions: [Permissions.Machines.Update],
            divider: false,
            isSwitch: true
        }
    ];
    return (_jsxs(Box, { sx: {
            padding: isXs ? '10px 12px' : '16px 8px 16px 20px',
            gap: '4px',
            borderRadius: '16px',
            border: '1px solid rgba(145, 158, 171, 0.2)',
            bgcolor: switchChecked ? 'rgba(0, 147, 126, 0.08)' : 'rgba(255, 255, 255, 1)',
            cursor: 'pointer'
        }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1.5, alignItems: 'center', sx: { flex: 1, minWidth: 0 }, onClick: onClick, children: [_jsx(AssetFolderIcon, { width: isXs ? 20 : 40, height: isXs ? 20 : 40 }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '2px', sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { noWrap: true, fontWeight: 500, fontSize: 15, color: 'text.primary', children: title }), _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(Tooltip, { open: isXs || isIpadMini || isIpadMiniLandscape
                                                        ? openTooltipDocuments === machine.id
                                                        : undefined, disableFocusListener: isXs || isIpadMini || isIpadMiniLandscape, disableTouchListener: isXs || isIpadMini || isIpadMiniLandscape, disableHoverListener: isXs || isIpadMini || isIpadMiniLandscape, title: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", machine.processedDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processingDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: [' ', machine.processingDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.unprocessableDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", machine.unprocessableDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.failedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", machine.failedDocumentCount] })] }) })] }), arrow: true, placement: 'top', slotProps: {
                                                        popper: { disablePortal: false }
                                                    }, children: _jsx(Typography, { onClick: isXs || isIpadMini || isIpadMiniLandscape
                                                            ? function (e) {
                                                                e.stopPropagation();
                                                                setOpenTooltipDocuments(function (prev) {
                                                                    return prev === machine.id ? null : machine.id;
                                                                });
                                                            }
                                                            : undefined, noWrap: true, variant: 'body2', color: 'text.secondary', sx: { cursor: 'pointer' }, children: "".concat(machine.modelCount, " ").concat(translate(machine.modelCount === 1 ? 'assets.model' : 'assets.models'), " . ").concat(machine.totalDocumentCount, " ").concat(translate(machine.totalDocumentCount === 1 ? 'common.document' : 'common.documents')) }) }) }), isSuperAdmin && (_jsx(Typography, { noWrap: true, variant: 'caption', color: theme.palette.text.tertiary, children: machine.companyName })), machine.isLinked && (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: [_jsx(Link05Icon, { width: 24, height: 24 }), _jsx(Typography, { noWrap: true, variant: 'caption', color: theme.palette.text.tertiary, children: 'dyanmic data here' })] }))] })] })] }), _jsx(Chip, { size: 'small', variant: 'soft', color: switchChecked ? 'primary' : 'error', label: switchChecked ? translate('common.active') : translate('common.inactive') }), _jsx(IconButton, { size: 'small', onClick: function (event) {
                            event.stopPropagation();
                            handleMenuOpen(event);
                        }, children: _jsx(MoreVerticalCircle01Icon, {}) })] }), _jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function (event) {
                    event.stopPropagation();
                    handleMenuClose();
                }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, onClick: function (event) { return event.stopPropagation(); }, children: menuItems.map(function (menuItem) {
                    var _a, _b;
                    return (_jsx(ProtectedElement, { permissions: (_a = menuItem.permissions) !== null && _a !== void 0 ? _a : [], children: _jsxs(MenuItem, { divider: menuItem.divider, sx: { color: menuItem.color }, onClick: function (event) {
                                event.stopPropagation();
                                handleMenuClose();
                                menuItem.onClick();
                            }, disabled: (_b = menuItem.disabled) !== null && _b !== void 0 ? _b : false, children: [_jsx(ListItemIcon, { children: menuItem.isSwitch ? (_jsx(Switch, { size: 'small', color: 'primary', sx: { right: 5 }, checked: switchChecked })) : (_jsx(menuItem.icon, { fontSize: 20, color: menuItem.color })) }), _jsx(ListItemText, { children: menuItem.text })] }) }, menuItem.text));
                }) })] }));
};
export default MachineFolderCard;
